import { render, staticRenderFns } from "./DeviceSettingDialog2.vue?vue&type=template&id=b4da0586&scoped=true"
import script from "./DeviceSettingDialog2.vue?vue&type=script&lang=js"
export * from "./DeviceSettingDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4da0586",
  null
  
)

export default component.exports